import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PortalTypeEnum } from '@ats/api/cm';
import { CmCookiePolicyService, CmSettingsService, PortalCoreFeature } from '@ats/cm/core';
import { Observable, of, switchMap } from 'rxjs';

@Component({
    selector: 'cm-cookie-modal',
    templateUrl: './cookie-modal.component.html',
    styleUrls: ['./cookie-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CmCookieModalComponent {
	isLoggedIn: Observable<boolean>;
	readonly locFeature: PortalCoreFeature;

	constructor(
		private readonly dialogRef: MatDialogRef<CmCookieModalComponent>,
		@Inject(MAT_DIALOG_DATA) private readonly data: { id: number },
		private readonly settings: CmSettingsService,
		private readonly cookiePolicyService: CmCookiePolicyService
	) {
		this.locFeature = this.settings.portalCoreFeature;
	}

	accept(): void {
		of(this.settings.portal === PortalTypeEnum.CandidatePortal)
			.pipe(
				switchMap(isCandidatePortal =>
					isCandidatePortal
						? this.cookiePolicyService.insertCandidateHistory$(this.data.id)
						: this.cookiePolicyService.insertWebUserHistory$(this.data.id)
				)
			)
			.subscribe(() => {
				this.cookiePolicyService.acceptCookie(this.data.id);
				this.dialogRef.close();
			});
	}
}
